/**
 * Хлебные крошки с анимацией вперёд/назад (02_GPT-MODULAR).
 * Вперёд — допечатывается сегмент, назад — реверс до текущего пути.
 */

import { useRef, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getBreadcrumbPath, breadcrumbToText } from "../../config/breadcrumbRoutes";
import Typewriter from "../Typewriter/Typewriter";
import "./BreadcrumbAnimated.css";

function BreadcrumbAnimated({ speed = 70, delay = 300 }) {
    const location = useLocation();
    const pathname = location.pathname;
    const path = getBreadcrumbPath(pathname);
    const fullText = breadcrumbToText(path);

    const prevPathRef = useRef(null);
    const [reverseFrom, setReverseFrom] = useState(null);
    const [staticPart, setStaticPart] = useState("");
    const [key, setKey] = useState(0);

    useEffect(() => {
        const prevPath = prevPathRef.current;

        if (prevPath === null) {
            // Первая загрузка - печатаем весь путь
            setReverseFrom(null);
            setStaticPart("");
            setKey((k) => k + 1);
        } else if (path.length < prevPath.length) {
            // Идем назад - используем реверс (стирание)
            const prevFull = breadcrumbToText(prevPath);
            setReverseFrom(prevFull);
            setStaticPart("");
            setKey((k) => k + 1);
        } else if (path.length > prevPath.length) {
            // Идем вперед - находим общую часть и печатаем новую
            let commonLength = 0;
            for (let i = 0; i < Math.min(path.length, prevPath.length); i++) {
                if (path[i] === prevPath[i]) {
                    commonLength = i + 1;
                } else {
                    break;
                }
            }
            
            if (commonLength > 0) {
                const common = path.slice(0, commonLength);
                setStaticPart(breadcrumbToText(common));
            } else {
                setStaticPart("");
            }
            setReverseFrom(null);
            setKey((k) => k + 1);
        } else {
            // Переход на том же уровне - печатаем весь путь
            setReverseFrom(null);
            setStaticPart("");
            setKey((k) => k + 1);
        }

        prevPathRef.current = path;
    }, [pathname, path]);

    if (reverseFrom !== null) {
        // Режим стирания (идем назад)
        return (
            <p className="group-6__breadcrumb">
                <Typewriter
                    key={key}
                    reverse
                    fullText={reverseFrom}
                    targetText={fullText}
                    speed={speed}
                    delay={delay}
                />
            </p>
        );
    }

    // Режим печати вперед
    if (staticPart === "") {
        // Нет общей части - печатаем всё
        return (
            <p className="group-6__breadcrumb">
                <Typewriter key={key} text={fullText} speed={speed} delay={delay} />
            </p>
        );
    }

    // Есть общая часть - показываем её статично и печатаем новую часть
    const newPart = fullText.substring(staticPart.length);
    return (
        <p className="group-6__breadcrumb">
            {staticPart}
            <Typewriter key={key} text={newPart} speed={speed} delay={delay} />
        </p>
    );
}

export default BreadcrumbAnimated;
// components/BreadcrumbAnimated/BreadcrumbAnimated.js
